import actions from './store/actions';
import createRouterMiddleware from '@synergycms_core/middlewares/actionRouter';
import initializeStore from './start';

import {correctSelection} from "./utils/utils";
import storage from "synergycms_core/src/utils/storage";



const RouteResolver = (arrayHash, queryObj) => {
  return (dispatch, getState) => {
    let [baseRoute] = arrayHash;

    initializeStore(baseRoute, arrayHash, queryObj, dispatch);
    dispatch(actions.customer.params.createFromUrl(queryObj));
    dispatch(actions.router.update());
    dispatch(actions.app.load(true));

    if (true) {
      // CANVI URL
      let hasSelection = correctSelection();
      if (!hasSelection) {
        window.location.href = window.engine_sygy_data.url.gift_voucher_list;
        storage.unset('gift_voucher_selection');
      }
    } else {
      dispatch(actions.router.error());
    }
  };
};

export default createRouterMiddleware(RouteResolver, { fireInitial: true });
